"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapFilterConfigItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class MapFilterConfigItemDto {}
exports.MapFilterConfigItemDto = MapFilterConfigItemDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueActivityType,
  description: 'Stable activity stat key used for map filtering.'
}), __metadata("design:type", String)], MapFilterConfigItemDto.prototype, "key", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Display label in the map filter UI.'
}), __metadata("design:type", String)], MapFilterConfigItemDto.prototype, "label", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Display order in the map filter list (0 = first). Must be unique per filter set.',
  minimum: 0
}), __metadata("design:type", Number)], MapFilterConfigItemDto.prototype, "position", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Filter chip / marker accent color (hex).'
}), __metadata("design:type", String)], MapFilterConfigItemDto.prototype, "color", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.MapFilterState,
  description: 'Locked / Init / Default control visibility and default on-state; Hidden omits the filter from the UI.'
}), __metadata("design:type", String)], MapFilterConfigItemDto.prototype, "state", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Optional extension payload for future filter types.'
}), __metadata("design:type", Object)], MapFilterConfigItemDto.prototype, "payload", void 0);
//# sourceMappingURL=MapFilterConfigItem.dto.js.map